<template>
  <aside :class="$style.sidebar">
    <div :class="$style.inner">
      <div v-if="logo.url" :class="$style.logoContainer">
        <PImage :image-object="logo" :class="$style.logo" />
      </div>
      <p v-if="date" :class="$style.date">
        {{ $d(new Date(date), 'longDate') }}
      </p>
      <Title :title-params="title" :class="$style.title" />
    </div>
  </aside>
</template>

<script>
import PImage from '~/components/PImage'
import Title from '~/components/Title'

export default {
  name: 'PressSidebar',

  components: {
    PImage,
    Title,
  },

  props: {
    logo: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: Array,
      default: () => [],
    },
    date: {
      type: String,
      default: '',
    },
  },

  beforeMount() {
    const element = document?.getElementById('mainRoot')
    if (element) element.style.overflowX = 'initial' // So the sidebar can be sticky
  },
}
</script>

<style lang="scss" module>
.inner {
  position: sticky;
  top: 96px;
}

.logoContainer {
  display: flex;
  height: 330px;
  margin-bottom: 80px;
}

.logo {
  align-self: flex-end;
  max-width: 240px;
}

.date {
  color: $gray-300;
  font-weight: 700;
  text-transform: uppercase;
}

.title {
  @include typo-extra-title;
  margin-top: 8px;

  font-weight: 200;
}
</style>
